import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getAgeHourById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetRowData = (rowId?: number | null) => {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ['ageHours', 'get', rowId],
    queryFn: async () => {
      const { data } = await getAgeHourById(rowId);
      return data;
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('ageHours.errors.errorDuringFetching')
      });
    }
  });

  return { isFetching, data };
};

export default useGetRowData;
